import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  NgZone,
  OnInit,
  Output,
  ViewChild
} from "@angular/core";
import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import {NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
  selector: 'vb-signature',
  templateUrl: './signature.component.html',
  styleUrls: ['./signature.component.css'],
  providers: [
    {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SignatureComponent), multi: true},
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignatureComponent implements AfterViewInit, OnInit, AfterViewChecked {

  @Input()
  width: number;

  @Input()
  height: number;

  @ViewChild(SignaturePad) signaturePad: SignaturePad;
  @ViewChild('padContainer') container: ElementRef;

  private lastWidth;
  private lastHeight;

  signaturePadOptions = {};

  @Output()
  signatureChange: EventEmitter<string> = new EventEmitter();

  public propagateChange: Function = null;
  public propagateTouched: Function = null;

  private _signature: any = null;

  get signature(): any {
    return this._signature;
  }

  set signature(value: any) {
    this._signature = value;
    this.signatureChange.emit(value);
    this.propagateChange(this._signature);
  }

  public writeValue(value: any): void {
    if (!value) {
      return;
    }
    this.signature = value;
    this.signaturePad.fromDataURL(this.signature);
  }

  public registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.propagateTouched = fn;
  }

  constructor(private cd: ChangeDetectorRef, private ngZone: NgZone) {
  }


  ngOnInit(): void {
    this.signaturePadOptions = {
      backgroundColor: 'rgba(255,255,255,0.0)',
      canvasWidth: 100,
      canvasHeight: 100
    };
  }

  ngAfterViewInit() {
    this.size();
  }

  ngAfterViewChecked(): void {
    this.size();
  }

  drawComplete() {
    this.signature = this.signaturePad.toDataURL();
  }

  drawStart() {

  }

  clearSignautre() {
    this.signature = null;
    this.signaturePad.clear();
    this.cd.markForCheck();
  }

  size() {

    if (!this.signaturePad) {
      return;
    }

    let w = this.width && this.width > 0 ? this.width : this.container.nativeElement.clientWidth;
    let h = this.height && this.height > 0 ? this.height : this.container.nativeElement.clientHeight;

    if (this.lastHeight == h && this.lastWidth == w) {
      return;
    }

    this.lastWidth = w;
    this.lastHeight = h;

    this.signaturePad.set('canvasWidth', w);
    this.signaturePad.set('canvasHeight', h);

    this.signaturePad.clear(); // invoke functions from szimek/signature_pad API

    this.cd.markForCheck();
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/components/signature/signature.component.ts